import {
  Button,
  createStyles,
  Drawer,
  Grid,
  Icon,
  Theme,
  Typography,
  withStyles,
  WithStyles,
} from '@material-ui/core';
import * as classNames from 'classnames';
import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { connect } from 'react-redux';
import firebaseApp from '../firebase';
import { IProfileState } from '../profile/model';
import { DASHBOARD_PATH, MY_READING_PATH } from '../route-constants';
import { compose } from '../utils';
import NavigationDrawerLink from './NavigationDrawerLink';

const avatarSize = 50;
const styles = (theme: Theme) =>
  createStyles({
    avatar: {
      alignItems: 'center',
      backgroundColor: theme.palette.secondary[500],
      borderRadius: avatarSize,
      display: 'flex',
      height: avatarSize,
      justifyContent: 'center',
      marginRight: 10,
      width: avatarSize,
    },
    avatarIcon: {
      fontSize: `36px`,
      marginBottom: 2,
      marginLeft: 1,
      overflow: 'visible',
    },
    bottom: {
      color: theme.palette.grey[800],
      padding: `20px 30px`,
    },
    container: {
      color: `#FFFFFF`,
      height: `100%`,
      width: 360,
    },
    logo: {
      backgroundImage: `url("static/bb_logo_white_w200.png")`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: `100px auto`,
      height: 32,
      marginTop: 10,
      width: 100,
    },
    main: {
      flex: 1,
      padding: `80px 20px 20px 40px`,
    },
    menuIcon: {
      marginRight: `10px`,
    },
    profile: {
      paddingLeft: 40,
    },
    profileName: {
      fontSize: `18px`,
    },
    top: {
      backgroundColor: theme.palette.grey[800],
      height: 200,
      padding: `10px`,
    },
  });

interface IState {
  drawerOpen: boolean;
}

export interface IProps extends WithStyles<typeof styles> {
  drawerOpen: boolean;
  onClose: () => any;
  profile: IProfileState;
}

export type allProps = IProps & InjectedTranslateProps;

class NavigationDrawer extends React.Component<allProps> {
  public state: IState;

  constructor(props: allProps) {
    super(props);
    this.state = {
      drawerOpen: false,
    };
  }

  public render() {
    const { classes, onClose, profile, t } = this.props;
    const { drawerOpen } = this.state;

    return (
      <Drawer open={drawerOpen} onClose={onClose}>
        <Grid
          container={true}
          direction="column"
          className={classes.container}
          justify="space-between"
        >
          <Grid
            container={true}
            direction="column"
            alignItems="center"
            spacing={0}
            justify="space-between"
            className={classes.top}
          >
            <div className={classes.logo} />
            <Grid
              container={true}
              direction="row"
              alignItems="center"
              className={classes.profile}
            >
              <div className={classes.avatar}>
                <Icon
                  className={classNames(classes.avatarIcon, {
                    'icon-avatar-boy': true,
                  })}
                />
              </div>
              {profile && profile.name ? (
                <Typography
                  variant="subheading"
                  color="inherit"
                  className={classes.profileName}
                  data-uid={profile.uid}
                >
                  {profile.name}
                </Typography>
              ) : null}
            </Grid>
          </Grid>

          <Grid className={classes.main}>
            <NavigationDrawerLink
              anchor={t('web_link_home')}
              iconClass="icon-menu-home"
              href={DASHBOARD_PATH}
              onClick={this.navClick}
            />

            <NavigationDrawerLink
              anchor={t('web_link_my_reading')}
              iconClass="icon-menu-myreading"
              href={MY_READING_PATH}
              onClick={this.navClick}
            />
          </Grid>

          <Grid
            container={true}
            direction="column"
            className={classes.bottom}
            alignItems="flex-start"
          >
            <Button onClick={this.handleLogout} color="inherit">
              <Icon
                className={classNames(classes.menuIcon, {
                  'icon-menu-logout': true,
                })}
              />
              {t('cms_button_logout')}
            </Button>
          </Grid>
        </Grid>
      </Drawer>
    );
  }

  public componentDidMount() {
    if (this.state.drawerOpen !== this.props.drawerOpen) {
      this.setState({
        drawerOpen: this.props.drawerOpen,
      });
    }
  }

  public componentDidUpdate(prevProps: allProps) {
    if (prevProps.drawerOpen !== this.props.drawerOpen) {
      this.setState({
        drawerOpen: this.props.drawerOpen,
      });
    }
  }

  private navClick = () => {
    this.props.onClose();
  };

  private handleLogout = (e: any) => {
    e.preventDefault();
    firebaseApp.auth().signOut();
  };
}

const mapStateToProps = (state: {
  profile: IProfileState;
}): any => ({
  profile: state.profile,
});

const enhance = compose(
  translate(),
  connect(mapStateToProps, {}),
  withStyles(styles),
);
export default enhance(NavigationDrawer);



// WEBPACK FOOTER //
// ./src/components/NavigationDrawer.tsx